import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./responsive.css";
import Dashboard from "./pages/Dashboard";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import React, { createContext, useEffect, useState } from "react";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Products from "./pages/Products";
import Category from "./pages/Category/categoryList";
import ProductDetails from "./pages/ProductDetails";
import ProductUpload from "./pages/Products/addProduct";
import EditProduct from "./pages/Products/editProduct";
import CategoryAdd from "./pages/Category/addCategory";
import EditCategory from "./pages/Category/editCategory";
import SubCatAdd from "./pages/Category/addSubCat";
import SubCatList from "./pages/Category/subCategoryList";
import AddProductRAMS from "./pages/Products/addProductRAMS";
import ProductWeight from "./pages/Products/addProductWeight";
import ProductSize from "./pages/Products/addProductSize";
import Orders from "./pages/Orders";
import AddHomeBannerSlide from "./pages/HomeBanner/addHomeSlide";
import HomeBannerSlideList from "./pages/HomeBanner/homeSlideList";
import EditHomeBannerSlide from "./pages/HomeBanner/editSlide";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import LoadingBar from "react-top-loading-bar";
import { fetchDataFromApi } from "./utils/api";

import axios from "axios";
import BannersList from "./pages/Banners/bannerList";
import AddBanner from "./pages/Banners/addHomeBanner";
import EditBanner from "./pages/Banners/editHomeBanner";

import HomeSideBannersList from "./pages/HomeSideBanners/bannerList";
import AddHomeSideBanner from "./pages/HomeSideBanners/addHomeSideBanner";
import EditHomeSideBanner from "./pages/HomeSideBanners/editHomeSideBanner";

import HomeBottomBannersList from "./pages/HomeBottomBanners/bannerList";
import AddHomeBottomBanner from "./pages/HomeBottomBanners/addHomeBottomBanner";
import EditHomeBottomBanner from "./pages/HomeBottomBanners/editHomeBottomBanner";
import MyAccount from "./pages/MyAccount";
import VerifyAccount from "./pages/OtpVerify";
import AllDeliveryPersons from './pages/DeliveryPersons/AllDeliveryPersons';
import PendingApprovals from './pages/DeliveryPersons/PendingApprovals';
import ActiveDeliveryPersons from './pages/DeliveryPersons/ActiveDeliveryPersons';
import ProfileUpdateRequests from './pages/ProfileUpdateRequests/ProfileUpdateRequests';
import { AdminAuthProvider } from './context/AdminAuthContext';

import OfferBannersList from './pages/HomeOfferBanners';
import AddOfferBanner from './pages/HomeOfferBanners/AddOfferBanner';
import EditOfferBanner from './pages/HomeOfferBanners/EditOfferBanner';
import ViewDetails from './pages/HomeOfferBanners/ViewDetails';
import ActiveOffers from './pages/HomeOfferBanners/ActiveOffers';
import ProductSearch from './pages/HomeOfferBanners/ProductSearch';



import ActiveFestiveOffers from "./pages/HomeFestive/ActiveFestiveOffers";
import AddFestiveBanner from "./pages/HomeFestive/AddFestiveBanner";
import EditFestiveBanner from "./pages/HomeFestive/EditFestiveBanner";
import ViewFestiveDetails from "./pages/HomeFestive/ViewFestiveDetails";
import Festive from "./pages/HomeFestive/festive";






// In your routes
import EditSubCat from './pages/Category/editSubCat';

const MyContext = createContext();

function App() {
  const [orders, setOrders] = useState([]);
  const [isToggleSidebar, setIsToggleSidebar] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isHideSidebarAndHeader, setisHideSidebarAndHeader] = useState(false);
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "light"
  );
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [catData, setCatData] = useState([]);
  const [user, setUser] = useState({
    name: "",
    email: "",
    userId: "",
  });

  const [isOpenNav, setIsOpenNav] = useState(false);

  const [baseUrl, setBaseUrl] = useState("http://localhost:4000");

  const [progress, setProgress] = useState(0);
  const [alertBox, setAlertBox] = useState({
    msg: "",
    error: false,
    open: false,
  });

  const [selectedLocation, setSelectedLocation] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setselectedCountry] = useState("");

  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark");
      document.body.classList.remove("light");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.add("light");
      document.body.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [theme]);



  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token !== "" && token !== undefined && token !== null) {
      setIsLogin(true);

      const userData = JSON.parse(localStorage.getItem("user"));
      setUser(userData);
    } else {
      setIsLogin(false);
    }
  }, [isLogin, localStorage.getItem("user")]);



  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlertBox({
      open: false,
    });
  };

  useEffect(() => {
    setProgress(20);
    fetchCategory();
  }, []);

  const fetchCategory = () => {
    fetchDataFromApi("/api/category").then((res) => {
      setCatData(res);
      setProgress(100);
    });
  };

  const openNav = () => {
    setIsOpenNav(true);
  };

  const values = {
    isToggleSidebar,
    setIsToggleSidebar,
    isLogin,
    setIsLogin,
    isHideSidebarAndHeader,
    setisHideSidebarAndHeader,
    theme,
    setTheme,
    alertBox,
    setAlertBox,
    setProgress,
    baseUrl,
    catData,
    fetchCategory,
    setUser,
    user,
    countryList,
    selectedCountry,
    setselectedCountry,
    windowWidth,
    openNav,
    setIsOpenNav,
    orders,
    setOrders,
  };

  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <MyContext.Provider value={values}>
          <LoadingBar
            color="#f11946"
            progress={progress}
            onLoaderFinished={() => setProgress(0)}
            className="topLoadingBar"
          />

          <Snackbar
            open={alertBox.open}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              autoHideDuration={6000}
              severity={alertBox.error === false ? "success" : "error"}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {alertBox.msg}
            </Alert>
          </Snackbar>

          {isHideSidebarAndHeader !== true && <Header />}
          <div className="main d-flex">
            {isHideSidebarAndHeader !== true && (
              <>
                <div
                  className={`sidebarOverlay d-none ${isOpenNav === true && "show"
                    }`}
                  onClick={() => setIsOpenNav(false)}
                ></div>
                <div
                  className={`sidebarWrapper ${isToggleSidebar === true ? "toggle" : ""
                    } ${isOpenNav === true ? "open" : ""}`}
                >
                  <Sidebar />
                </div>
              </>
            )}

            <div
              className={`content ${isHideSidebarAndHeader === true && "full"} ${isToggleSidebar === true ? "toggle" : ""
                }`}
            >
              <Routes>
                <Route path="/" exact={true} element={<Dashboard />} />
                <Route path="/dashboard" exact={true} element={<Dashboard />} />
                <Route path="/login" exact={true} element={<Login />} />
                <Route path="/signUp" exact={true} element={<SignUp />} />
                <Route path="/products" exact={true} element={<Products />} />
                <Route
                  path="/product/details/:id"
                  exact={true}
                  element={<ProductDetails />}
                />
                <Route
                  path="/product/upload"
                  exact={true}
                  element={<ProductUpload />}
                />
                <Route
                  path="/product/edit/:id"
                  exact={true}
                  element={<EditProduct />}
                />
                <Route path="/category" exact={true} element={<Category />} />
                <Route
                  path="/category/add"
                  exact={true}
                  element={<CategoryAdd />}
                />
                <Route
                  path="/category/edit/:id"
                  exact={true}
                  element={<EditCategory />}
                />
                <Route
                  path="/subCategory/"
                  exact={true}
                  element={<SubCatList />}
                />
                <Route
                  path="/subCategory/add"
                  exact={true}
                  element={<SubCatAdd />}
                />
                <Route
                  path="/productRAMS/add"
                  exact={true}
                  element={<AddProductRAMS />}
                />
                <Route
                  path="/productWEIGHT/add"
                  exact={true}
                  element={<ProductWeight />}
                />
                <Route
                  path="/productSIZE/add"
                  exact={true}
                  element={<ProductSize />}
                />
                <Route path="/orders/" exact={true} element={<Orders />} />
                <Route
                  path="/homeBannerSlide/add"
                  exact={true}
                  element={<AddHomeBannerSlide />}
                />
                <Route
                  path="/homeBannerSlide/list"
                  exact={true}
                  element={<HomeBannerSlideList />}
                />
                <Route
                  path="/homeBannerSlide/edit/:id"
                  exact={true}
                  element={<EditHomeBannerSlide />}
                />

                <Route path="/banners" exact={true} element={<BannersList />} />
                <Route path="/banners/add" exact={true} element={<AddBanner />} />
                <Route
                  path="/banners/edit/:id"
                  exact={true}
                  element={<EditBanner />}
                />

                <Route path="/homeSideBanners" exact={true} element={<HomeSideBannersList />} />
                <Route path="/homeSideBanners/add" exact={true} element={<AddHomeSideBanner />} />
                <Route
                  path="/homeSideBanners/edit/:id"
                  exact={true}
                  element={<EditHomeSideBanner />}
                />

                <Route path="/homeBottomBanners" exact={true} element={<HomeBottomBannersList />} />
                <Route path="/homeBottomBanners/add" exact={true} element={<AddHomeBottomBanner />} />
                <Route
                  path="/homeBottomBanners/edit/:id"
                  exact={true}
                  element={<EditHomeBottomBanner />}
                />
                <Route exact={true} path="/my-account" element={<MyAccount />} />
                <Route exact={true} path="/verify-account" element={<VerifyAccount />} />
                <Route path="/delivery-persons" element={<AllDeliveryPersons />} />
                <Route path="/delivery-persons/pending" element={<PendingApprovals />} />
                <Route path="/delivery-persons/active" element={<ActiveDeliveryPersons />} />
                <Route path="/deliveryprofile-request" element={<ProfileUpdateRequests />} />

                <Route path="/homeOfferBanners" element={<OfferBannersList />} />
                <Route path="/homeOfferBanners/add" element={<AddOfferBanner />} />
                <Route path="/homeOfferBanners/edit/:id" element={<EditOfferBanner />} />
                <Route path="/homeOfferBanners/details/:id" element={<ViewDetails />} />
                <Route path="/homeOfferBanners/active" element={<ActiveOffers />} />
                <Route path="/homeOfferBanners/products" element={<ProductSearch />} />
                <Route path="/subCategory/edit/:id" element={<EditSubCat />} />



                {/* Home Festive banner section */}


                <Route path="/homeFestiveBanners/add" element={<AddFestiveBanner />} />
                <Route path="/homeFestiveBanners/edit/:id" element={<EditFestiveBanner />} />
                <Route path="/homeFestiveBanners/details/:id" element={<ViewFestiveDetails />} />
                <Route path="/homeFestiveBanners/active" element={<ActiveFestiveOffers />} />
                <Route path="/homeFestiveBanners" element={<Festive />} />

                {/* Home Festive Banner Section */}


              </Routes>
            </div>
          </div>
        </MyContext.Provider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
export { MyContext };

